<template>
  <router-view />
</template>

<script>
export default {
  name: 'SchedulePageLayout',
}
</script>
